import React from 'react';

export default function IcDuplicar() {
  return (
    <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Organizacional/Calendário" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="ORG-/-CALENDARIO-/-NOVA-TAREFA-FILL" transform="translate(-899.000000, -297.000000)" fill="#000">
                <g id="CARD-NOVO" transform="translate(377.000000, 160.000000)">
                    <g id="Side-Menu" transform="translate(516.000000, 39.000000)">
                        <g id="ACOES">
                            <g id="Duplicar" transform="translate(0.000000, 89.000000)">
                                <g id="ICON-/-DUPLICAR" transform="translate(7.000000, 9.428571)">
                                    <path d="M10.5,0 C11.3268,0 12,0.6732 12,1.5 L12,8.1 C12,8.9268 11.3268,9.6 10.5,9.6 L10.2,9.6 L10.2,10.5 C10.2,11.3268 9.5268,12 8.7,12 L1.5,12 C0.6732,12 0,11.3268 0,10.5 L0,3.9 C0,3.0732 0.6732,2.4 1.5,2.4 L1.799,2.399 L1.8,1.5 C1.8,0.6732 2.4732,0 3.3,0 L10.5,0 Z M8.7,3 L2.10922398,2.99986067 C2.1061606,2.99995334 2.10308571,3 2.1,3 L2.09,2.999 L1.5,3 C1.0038,3 0.6,3.4038 0.6,3.9 L0.6,10.5 C0.6,10.9962 1.0038,11.4 1.5,11.4 L8.7,11.4 C9.1962,11.4 9.6,10.9962 9.6,10.5 L9.60013933,9.30922398 C9.60004666,9.3061606 9.6,9.30308571 9.6,9.3 L9.6,9.291 L9.6,3.9 C9.6,3.4038 9.1962,3 8.7,3 Z M10.5,0.6 L3.3,0.6 C2.8038,0.6 2.4,1.0038 2.4,1.5 L2.4,2.399 L8.7,2.4 C9.5268,2.4 10.2,3.0732 10.2,3.9 L10.2,9 L10.5,9 C10.9962,9 11.4,8.5962 11.4,8.1 L11.4,1.5 C11.4,1.0038 10.9962,0.6 10.5,0.6 Z" id="Combined-Shape"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
}
